export default __webpack_public_path__ + "3bfad788a927c2cfbeee5475d5b9243a.svg";